import { css } from 'styled-components';

const ltrStyles = css`
  // Font settings for English
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  
  // Default Ant Design styles are already LTR, so we don't need to override much
  
  // Ensure consistent alignment
  .ant-dropdown {
    text-align: left;
  }
  
  .ant-form-item-label {
    text-align: left;
  }
  
  .ant-modal-footer {
    text-align: right;
  }
  
  .ant-notification {
    right: auto;
    left: 24px;
  }
`;

export default ltrStyles;
